import GlobalBg from "@/components/GlobalBg";
import Ticker from "@/components/Ticker";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import About from "@/components/About";
import MireDrama from "@/components/MireDrama";
import AIProduction from "@/components/AIProduction";
import AIInfrastructure from "@/components/AIInfrastructure";
import HitTitles from "@/components/HitTitles";
import BusinessModel from "@/components/BusinessModel";
import AgencyModel from "@/components/AgencyModel";
import Expansion from "@/components/Expansion";
import AppDownload from "@/components/AppDownload";
import Partnership from "@/components/Partnership";
import ContactFooter from "@/components/ContactFooter";
import FloatingDownload from "@/components/FloatingDownload";

const Index = () => (
  <div style={{ background: "#080808", color: "#f5f5f5", fontFamily: "Inter, 'Noto Sans SC', sans-serif", minHeight: "100vh", position: "relative" }}>
    <GlobalBg />
    <Navbar />
    <Hero />
    <Ticker />
    <Stats />
    <About />
    <MireDrama />
    <AIProduction />
    <AIInfrastructure />
    <HitTitles />
    <BusinessModel />
    <AgencyModel />
    <Expansion />
    <AppDownload />
    <Partnership />
    <ContactFooter />
    <FloatingDownload />
  </div>
);

export default Index;
